import { createFileRoute } from '@tanstack/react-router';

import { InsightsAgentPage } from '@/areas/market-insights/MarketInsights/pages/InsightsAgentPage';
import { canUseInsightsAgent } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

// `/monitoring/insights-agent` (a draft) and `/monitoring/insights-agent/:conversationId`, one route. A draft moves
// to its conversation's URL once its first question is stored, while that question's run streams; as one route,
// the chat stays mounted there and the run goes on. A link to a draft passes `conversationId: undefined`; left out,
// the router fills it in from the current URL.
// It checks what the sidebar's New chat checks; the monitoring layout (`monitoring/route.tsx`) checks the rest.
export const Route = createFileRoute('/_authenticated/monitoring/_sidebar/insights-agent/{-$conversationId}')({
    staticData: { access: { permissions: canUseInsightsAgent }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const { conversationId } = Route.useParams();
    return <InsightsAgentPage conversationId={conversationId} />;
}
